export default {
  'maintenance.title': 'Under Maintenance!',
  'maintenance.desc':
    "This page is on maintenance for now. We're working hard to complete maintenance as soon as possible. Thanks for your understanding.",
  'maintenance.toHome': 'Back to Home',
};
